import { render, staticRenderFns } from "./ad-group-metrics-app.vue?vue&type=template&id=0505dca3"
import script from "./ad-group-metrics-app.vue?vue&type=script&lang=js"
export * from "./ad-group-metrics-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports